import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { I18n } from '@/app/core/i18n/i18n';
import { routeCrumbs } from '@/app/core/navigation/route-crumbs';

@Component({
    selector: '[app-breadcrumb]',
    standalone: true,
    imports: [CommonModule],
    // Phosphor Fill i ljuskine klase umesto PrimeIcons-a i `!` modifikatora. Ta tri
    // modifikatora su bila jedina u celoj aplikaciji, i postojala su da bi nadjacala
    // unlayered Avalon SCSS koji vise ne postoji.
    template: `
        <i class="ph-fill ph-house eg-crumb__sep" aria-hidden="true"></i>
        @for (item of breadcrumbs(); track $index; let last = $last) {
            @if (last) {
                <span class="eg-crumb__last">{{ i18n.routeText(item) }}</span>
            } @else {
                <span>{{ i18n.routeText(item) }}</span>
                <i class="ph-fill ph-caret-right eg-crumb__sep" aria-hidden="true"></i>
            }
        }
    `,
    host: {
        class: 'eg-crumb'
    }
})
export class AppBreadcrumb {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    readonly i18n = inject(I18n);

    private breadcrumbs$ = this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => routeCrumbs(this.activatedRoute.root.snapshot))
    );

    breadcrumbs = toSignal(this.breadcrumbs$, { initialValue: [] as string[] });
}
